/* ==========================================================================
   The Vibe Balance — theme interactivity (vanilla JS, no framework)
   Replaces the original mockup's DCLogic state machine with real
   Shopify Ajax Cart calls + small DOM-driven components.
   ========================================================================== */
(function(){
  "use strict";

  /* ---------------------------------------------------------------------
     Cart: add / update via Shopify Ajax API
     --------------------------------------------------------------------- */
  const Cart = {
    async add(variantId, quantity, sellingPlanId){
      const body = { items: [{ id: variantId, quantity: quantity || 1 }] };
      if (sellingPlanId) body.items[0].selling_plan = sellingPlanId;
      const res = await fetch('/cart/add.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
        body: JSON.stringify(body)
      });
      if (!res.ok) throw new Error('cart_add_failed');
      const item = await res.json();
      await Cart.refreshCount();
      return item;
    },
    async refreshCount(){
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach(el=>{
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      return cart;
    },
    async clear(){
      const res = await fetch('/cart/clear.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }
      });
      if (!res.ok) throw new Error('cart_clear_failed');
      await Cart.refreshCount();
    }
  };
  window.TVB = window.TVB || {};
  window.TVB.Cart = Cart;

  function showToast(productName){
    const toast = document.querySelector('[data-cart-toast]');
    if (!toast) return;
    toast.querySelector('[data-toast-name]').textContent = productName;
    toast.classList.add('is-visible');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(()=>toast.classList.remove('is-visible'), 2800);
  }

  document.addEventListener('submit', async function(e){
    const form = e.target.closest('form[data-add-to-cart-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[data-add-to-cart-btn]');
    const variantId = form.querySelector('[name="id"]').value;
    const qtyInput = form.querySelector('[name="quantity"]');
    const sellingPlanInput = form.querySelector('[name="selling_plan"]:checked, input[name="selling_plan"][data-active="true"]');
    const name = form.getAttribute('data-product-name') || '';
    const handle = form.getAttribute('data-product-handle') || '';
    try{
      if (btn){ btn.disabled = true; btn.dataset.originalText = btn.dataset.originalText || btn.textContent; btn.textContent = btn.dataset.addedText || '✓'; }
      await Cart.add(variantId, qtyInput ? parseInt(qtyInput.value||'1',10) : 1, sellingPlanInput ? sellingPlanInput.value : null);
      if (!UpsellPopup.showFor(handle)) CartDecision.show(name);
      if (btn){ setTimeout(()=>{ btn.disabled = false; btn.textContent = btn.dataset.originalText; }, 1800); }
    }catch(err){
      if (btn){ btn.disabled = false; btn.textContent = btn.dataset.originalText; }
      console.error('[TVB] add to cart failed', err);
    }
  });

  /* ---------------------------------------------------------------------
     "Comprar ya": adds the current product to cart via the same AJAX
     endpoint as "Agregar al carrito" (so AddToCart tracking fires the
     same way for both buttons), then redirects to checkout in JS instead
     of a native form POST — one fewer full-page round trip than the old
     form.submit() flow, which posted to /cart/add (a full reload) before
     the server-side redirect ever reached /checkout.
     --------------------------------------------------------------------- */
  document.addEventListener('click', async function(e){
    const btn = e.target.closest('[data-buy-now-btn]');
    if (!btn) return;
    const form = btn.closest('form[data-add-to-cart-form]');
    if (!form) return;
    const variantId = form.querySelector('[name="id"]').value;
    const qtyInput = form.querySelector('[name="quantity"]');
    btn.disabled = true;
    try{
      await Cart.clear();
      await Cart.add(variantId, qtyInput ? parseInt(qtyInput.value||'1',10) : 1);
      window.location.href = '/checkout';
    }catch(err){
      btn.disabled = false;
      console.error('[TVB] buy now failed', err);
    }
  });

  /* ---------------------------------------------------------------------
     COD quick form: lets a "pago contra entrega" shopper skip Shopify's
     generic checkout on the first screen (email-first, built for card
     payers) and instead fill name/phone/address up front, in a form that
     matches how a COD buyer actually thinks. On submit we add the item to
     cart (same Cart.add() as everywhere else, so AddToCart tracking still
     fires) and hand off to the real Shopify checkout with those fields
     pre-filled via the documented checkout[] query params, so the buyer
     lands with almost nothing left to type.
     --------------------------------------------------------------------- */
  document.addEventListener('click', function(e){
    const toggle = e.target.closest('[data-cod-quick-toggle]');
    if (!toggle) return;
    const panel = toggle.closest('div').parentElement.querySelector('[data-cod-quick-form]') || document.querySelector('[data-cod-quick-form]');
    if (!panel) return;
    const visible = panel.style.display !== 'none';
    panel.style.display = visible ? 'none' : 'block';
  });

  document.addEventListener('click', async function(e){
    const btn = e.target.closest('[data-cod-quick-submit]');
    if (!btn) return;
    const panel = btn.closest('[data-cod-quick-form]');
    if (!panel) return;
    const errorEl = panel.querySelector('[data-cod-quick-error]');
    const get = (name) => panel.querySelector('[data-cod-field="' + name + '"]').value.trim();
    const normalizePhone = function(raw){
      // Shopify's checkout silently drops the shipping_address[phone]
      // prefill when the value isn't a clean, validly-formatted phone
      // number — strip everything but digits and a leading +, then make
      // sure it carries the Chile country code so "9 1234 5678" and
      // "+56 9 1234 5678" both end up as "+56912345678".
      let p = raw.replace(/[^\d+]/g, '');
      if (p.indexOf('+') === -1){
        if (p.indexOf('56') === 0) p = '+' + p;
        else if (p.indexOf('0') === 0) p = '+56' + p.slice(1);
        else p = '+56' + p;
      }
      return p;
    };
    const fullName = get('full_name');
    const nameParts = fullName.split(/\s+/).filter(Boolean);
    const data = {
      first_name: nameParts[0] || '',
      last_name: nameParts.slice(1).join(' ') || nameParts[0] || '',
      phone: normalizePhone(get('phone')),
      address1: get('address1'),
      city: get('city'),
      province: get('province')
    };
    const missing = !fullName || Object.keys(data).some(function(k){ return !data[k]; });
    if (missing){
      if (errorEl) errorEl.style.display = 'block';
      return;
    }
    if (errorEl) errorEl.style.display = 'none';
    // Respetar el pack/cantidad que la persona haya elegido arriba en vez de
    // asumir siempre 1 unidad — lee los mismos campos ocultos id/quantity
    // que actualiza el selector de packs. El panel COD no vive dentro del
    // mismo <form> que los packs, así que ubicamos ese form por separado
    // en vez de asumir un ancestro común.
    const packGroup = document.querySelector('[data-pack-group]');
    const packForm = packGroup ? packGroup.closest('form') : null;
    const idInput = packForm ? packForm.querySelector('[name="id"]') : null;
    const qtyInput = packForm ? packForm.querySelector('[name="quantity"]') : null;
    const variantId = (idInput && idInput.value) || panel.getAttribute('data-variant-id');
    const quantity = parseInt((qtyInput && qtyInput.value) || '1', 10) || 1;
    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = 'Confirmando…';
    try{
      await Cart.clear();
      await Cart.add(variantId, quantity);
      panel.setAttribute('data-cod-submitted', 'true');
      const params = new URLSearchParams();
      params.set('checkout[shipping_address][first_name]', data.first_name);
      params.set('checkout[shipping_address][last_name]', data.last_name);
      params.set('checkout[shipping_address][phone]', data.phone);
      params.set('checkout[shipping_address][address1]', data.address1);
      params.set('checkout[shipping_address][city]', data.city);
      params.set('checkout[shipping_address][province]', data.province);
      params.set('checkout[shipping_address][country]', 'Chile');
      window.location.href = '/checkout?' + params.toString();
    }catch(err){
      btn.disabled = false;
      btn.textContent = originalText;
      console.error('[TVB] cod quick form failed', err);
    }
  });

  /* ---------------------------------------------------------------------
     Upsell popup: "complementa tu pedido" shown after adding a hero
     product (Almohada Cervical, Masajeador) to cart, offering related
     "lifestyle" products (AliExpress-style order-complete prompt).
     --------------------------------------------------------------------- */
  const UpsellPopup = (function(){
    const popup = document.querySelector('[data-upsell-popup]');
    const mapEl = document.querySelector('[data-upsell-map]');
    const mapExtraEl = document.querySelector('[data-upsell-map-extra]');
    let map = {};
    try{ if (mapEl) map = JSON.parse(mapEl.textContent); }catch(err){ console.error('[TVB] upsell map parse failed', err); }
    try{
      if (mapExtraEl){
        const extra = JSON.parse(mapExtraEl.textContent);
        Object.keys(extra).forEach(function(handle){
          if (!extra[handle] || !extra[handle].length) return;
          map[handle] = (map[handle] || []).concat(extra[handle]);
        });
      }
    }catch(err){ console.error('[TVB] upsell map-extra parse failed', err); }

    function itemMarkup(item){
      const wrap = document.createElement('div');
      wrap.style.cssText = 'display:flex;align-items:center;gap:12px;border:1px solid #e5e7eb;border-radius:6px;padding:10px;';
      const hasRealDiscount = item.standalonePrice !== item.bundlePrice;
      const priceMarkup = hasRealDiscount
        ? '<span style="font-family:\'DM Sans\',sans-serif;font-size:11px;color:#9ca3af;text-decoration:line-through;">' + item.standalonePrice + '</span>' +
          '<span style="font-family:\'Oswald\',sans-serif;font-size:14px;font-weight:700;color:#1F6B4A;">' + item.bundlePrice + '</span>'
        : '<span style="font-family:\'Oswald\',sans-serif;font-size:14px;font-weight:700;color:#1F6B4A;">' + item.bundlePrice + '</span>';
      const imgMarkup = item.image
        ? '<img src="' + item.image + '" alt="" style="width:56px;height:56px;object-fit:cover;border-radius:4px;flex-shrink:0;">'
        : '<div style="width:56px;height:56px;border-radius:4px;flex-shrink:0;background:#E6F1EA;border:1px dashed #1F6B4A;"></div>';
      wrap.innerHTML =
        imgMarkup +
        '<div style="flex:1;min-width:0;">' +
          '<a href="' + item.url + '" style="font-family:\'DM Sans\',sans-serif;font-size:13px;font-weight:500;color:#171520;text-decoration:none;display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + item.title + '</a>' +
          '<div style="display:flex;align-items:baseline;gap:6px;">' + priceMarkup +
          '</div>' +
        '</div>' +
        '<button type="button" data-upsell-add style="flex-shrink:0;background:#171520;color:#fff;border:none;border-radius:4px;padding:8px 14px;font-family:\'DM Sans\',sans-serif;font-size:12.5px;font-weight:500;cursor:pointer;">' + (window.TVB_STRINGS && window.TVB_STRINGS.upsellAdd || 'Agregar') + '</button>';

      const addBtn = wrap.querySelector('[data-upsell-add]');
      addBtn.addEventListener('click', async function(){
        addBtn.disabled = true;
        try{
          await Cart.add(item.variantId, 1);
          addBtn.textContent = (window.TVB_STRINGS && window.TVB_STRINGS.upsellAdded) || '✓ Agregado';
        }catch(err){
          addBtn.disabled = false;
          console.error('[TVB] upsell add failed', err);
        }
      });
      return wrap;
    }

    function showFor(handle){
      if (!popup || !handle || !map[handle] || !map[handle].length) return false;
      const itemsEl = popup.querySelector('[data-upsell-items]');
      itemsEl.innerHTML = '';
      map[handle].forEach(function(item){ itemsEl.appendChild(itemMarkup(item)); });
      popup.style.display = 'flex';
      return true;
    }
    function hide(){ if (popup) popup.style.display = 'none'; }

    if (popup){
      const closeBtn = popup.querySelector('[data-upsell-close]');
      const skipBtn = popup.querySelector('[data-upsell-skip]');
      if (closeBtn) closeBtn.addEventListener('click', hide);
      if (skipBtn) skipBtn.addEventListener('click', hide);
    }

    return { showFor: showFor, hide: hide };
  })();
  window.TVB.UpsellPopup = UpsellPopup;

  /* ---------------------------------------------------------------------------
     Cart decision panel: the default response to "Agregar al carrito" for
     any product that doesn't have a dedicated cross-sell (UpsellPopup
     handles those). Replaces a silent toast with one clear next step —
     go to checkout — plus a next-purchase coupon, since pushing a discount
     on the order in progress isn't worth the margin risk.
     --------------------------------------------------------------------- */
  const CartDecision = (function(){
    const panel = document.querySelector('[data-cart-decision]');
    if (!panel) return { show: function(){ return false; } };
    const nameEl = panel.querySelector('[data-cart-decision-name]');
    const closeBtn = panel.querySelector('[data-cart-decision-close]');
    const continueBtn = panel.querySelector('[data-cart-decision-continue]');
    const checkoutBtn = panel.querySelector('[data-cart-decision-checkout]');

    function hide(){ panel.style.display = 'none'; }
    function show(productName){
      if (nameEl){
        const label = (window.TVB_STRINGS && window.TVB_STRINGS.cartDecisionAdded) || '';
        nameEl.textContent = productName ? (productName + ' — ' + label) : label;
      }
      panel.style.display = 'flex';
      return true;
    }
    if (closeBtn) closeBtn.addEventListener('click', hide);
    if (continueBtn) continueBtn.addEventListener('click', hide);
    if (checkoutBtn) checkoutBtn.addEventListener('click', function(){
      hide();
      scrollToCodForm();
    });
    return { show: show, hide: hide };
  })();
  window.TVB.CartDecision = CartDecision;

  document.addEventListener('click', function(e){
    const dismiss = e.target.closest('[data-toast-dismiss]');
    if (dismiss){ dismiss.closest('[data-cart-toast]').classList.remove('is-visible'); }
  });

  Cart.refreshCount();

  /* ---------------------------------------------------------------------
     Marquee carousels: manual prev/next arrows on top of the auto-scroll.
     Clicking an arrow freezes the CSS animation and steps the track by
     one item width; the track is duplicated (two full sets) so stepping
     wraps around seamlessly at the halfway point, same as the animation.
     --------------------------------------------------------------------- */
  document.addEventListener('click', function(e){
    const btn = e.target.closest('[data-marquee-prev], [data-marquee-next]');
    if (!btn) return;
    const wrap = btn.closest('.tvb-marquee-wrap');
    const track = wrap && wrap.querySelector('.tvb-marquee-track');
    if (!track) return;

    const halfWidth = track.scrollWidth / 2;
    const firstItem = track.querySelector('.tvb-marquee-item');
    const step = firstItem ? firstItem.getBoundingClientRect().width + 20 : 290;

    let current;
    if (!track.classList.contains('is-manual')){
      // First manual click: read where the CSS auto-scroll animation actually
      // is right now (its computed transform), so switching to manual control
      // doesn't make the track jump. animation:none only takes effect once
      // is-manual is added below, so this read must happen before that.
      const computed = getComputedStyle(track).transform;
      let tx = 0;
      const match = computed && computed !== 'none' ? computed.match(/matrix\(([^)]+)\)/) : null;
      if (match){
        const parts = match[1].split(',').map(parseFloat);
        tx = parts[4] || 0;
      }
      current = tx;
      track.classList.add('is-manual');
    } else {
      current = track.dataset.offset ? parseFloat(track.dataset.offset) : 0;
    }

    let next = btn.hasAttribute('data-marquee-next') ? current - step : current + step;
    if (next <= -halfWidth) next += halfWidth;
    if (next > 0) next -= halfWidth;

    track.dataset.offset = next;
    track.style.transform = 'translateX(' + next + 'px)';
  });

  /* ---------------------------------------------------------------------
     Mobile nav toggle
     --------------------------------------------------------------------- */
  document.addEventListener('click', function(e){
    const toggle = e.target.closest('[data-mobile-nav-toggle]');
    if (!toggle) return;
    const nav = document.querySelector('[data-mobile-nav]');
    if (nav) nav.classList.toggle('is-open');
  });

  /* ---------------------------------------------------------------------
     Announcement bar rotator
     --------------------------------------------------------------------- */
  (function announcementRotator(){
    const el = document.querySelector('[data-announcement-rotator]');
    if (!el) return;
    const items = Array.from(el.querySelectorAll('[data-announcement-item]'));
    if (items.length < 2) return;
    let i = 0;
    setInterval(()=>{
      items[i].style.display = 'none';
      i = (i+1) % items.length;
      items[i].style.display = '';
    }, 4500);
  })();

  /* ---------------------------------------------------------------------
     Accordion (FAQ, "why does this happen")
     --------------------------------------------------------------------- */
  document.addEventListener('click', function(e){
    const trigger = e.target.closest('[data-accordion-trigger]');
    if (!trigger) return;
    const item = trigger.closest('[data-accordion-item]');
    const group = item.closest('[data-accordion-group]');
    const singleOpen = group && group.dataset.accordionSingle === 'true';
    if (singleOpen){
      group.querySelectorAll('[data-accordion-item]').forEach(other=>{
        if (other !== item) other.classList.remove('is-open');
      });
    }
    item.classList.toggle('is-open');
  });

  /* ---------------------------------------------------------------------
     Catalog collection-tab filter (client side show/hide)
     --------------------------------------------------------------------- */
  document.addEventListener('click', function(e){
    const tab = e.target.closest('[data-catalog-tab]');
    if (!tab) return;
    const grid = document.querySelector('[data-catalog-grid]');
    if (!grid) return;
    const slug = tab.getAttribute('data-catalog-tab');
    grid.querySelectorAll('[data-catalog-tab-group]').forEach(t=>t.classList.remove('is-active'));
    tab.classList.add('is-active');
    grid.querySelectorAll('[data-product-card]').forEach(card=>{
      const cardSlugs = (card.getAttribute('data-collections')||'').split(',');
      card.style.display = (slug === 'all' || cardSlugs.includes(slug)) ? '' : 'none';
    });
  });

  /* ---------------------------------------------------------------------
     Product gallery thumbnails + lightbox
     --------------------------------------------------------------------- */
  document.addEventListener('click', function(e){
    const thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb){
      const main = document.querySelector('[data-gallery-main] img');
      if (main) main.src = thumb.getAttribute('data-full-src');
      thumb.closest('[data-gallery-thumbs]').querySelectorAll('[data-gallery-thumb]').forEach(t=>t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    }
    const zoomTarget = e.target.closest('[data-lightbox-src]');
    if (zoomTarget){
      const lightbox = document.querySelector('[data-lightbox]');
      if (lightbox){
        lightbox.querySelector('img').src = zoomTarget.getAttribute('data-lightbox-src');
        lightbox.classList.add('is-visible');
      }
    }
    if (e.target.closest('[data-lightbox-close]')){
      const lightbox = document.querySelector('[data-lightbox]');
      if (lightbox) lightbox.classList.remove('is-visible');
    }
  });

  /* ---------------------------------------------------------------------
     Buy mode toggle: one-time purchase vs subscription (Selling Plans)
     --------------------------------------------------------------------- */
  document.addEventListener('click', function(e){
    const modeBtn = e.target.closest('[data-buy-mode]');
    if (!modeBtn) return;
    const wrap = modeBtn.closest('[data-buy-mode-group]');
    wrap.querySelectorAll('[data-buy-mode]').forEach(b=>b.classList.remove('is-active'));
    modeBtn.classList.add('is-active');
    const mode = modeBtn.getAttribute('data-buy-mode');
    const form = wrap.closest('form');
    const sellingPlanField = form.querySelector('[data-selling-plan-id]');
    if (sellingPlanField){
      sellingPlanField.dataset.active = (mode === 'subscribe') ? 'true' : 'false';
      sellingPlanField.disabled = (mode !== 'subscribe');
    }
  });

  /* ---------------------------------------------------------------------
     Pack / quantity selector (variant switch)
     --------------------------------------------------------------------- */
  document.addEventListener('click', function(e){
    const pack = e.target.closest('[data-pack-option]');
    if (!pack) return;
    const wrap = pack.closest('[data-pack-group]');
    wrap.querySelectorAll('[data-pack-option]').forEach(p=>p.classList.remove('is-selected'));
    pack.classList.add('is-selected');
    const form = wrap.closest('form');
    const variantInput = form.querySelector('[name="id"]');
    if (variantInput) variantInput.value = pack.getAttribute('data-variant-id');
    const qtyInput = form.querySelector('[name="quantity"]');
    if (qtyInput && pack.getAttribute('data-variant-qty')) qtyInput.value = pack.getAttribute('data-variant-qty');
    // Mantener el resumen del formulario COD rápido en sincro con el pack
    // elegido — el panel COD no vive dentro de este mismo <form>, así que
    // se busca en toda la página en vez de asumir un ancestro común.
    const price = pack.getAttribute('data-pack-price');
    if (price){
      const subtotalEl = document.querySelector('[data-cod-quick-subtotal-value]');
      if (subtotalEl) subtotalEl.textContent = price;
    }
  });

  /* ---------------------------------------------------------------------
     Sticky mobile buy bar — shows once main CTA scrolls out of view
     --------------------------------------------------------------------- */
  (function stickyBuy(){
    const bar = document.querySelector('[data-sticky-buy]');
    const anchor = document.querySelector('[data-sticky-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries)=>{
      entries.forEach(entry=>{
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '-80px 0px 0px 0px' });
    io.observe(anchor);
  })();

  /* Barra fija: se esconde mientras el formulario EasySell está a la vista (ahí sobraba y tapaba
     el botón "Confirmar pedido"). En celular la barra está forzada visible por CSS, así que se
     usa una clase propia con más prioridad (.sx-form-en-vista, en theme.css). */
  (function stickyVsForm(){
    const bar = document.querySelector('[data-sticky-buy]');
    if (!bar || !('IntersectionObserver' in window)) return;
    const vigilar = (intentos)=>{
      const es = document.querySelector('#easysell');
      if (!es) { if (intentos > 0) setTimeout(()=>vigilar(intentos - 1), 700); return; }
      new IntersectionObserver((entries)=>{
        entries.forEach(entry=> bar.classList.toggle('sx-form-en-vista', entry.isIntersecting));
      }, { threshold: 0.12 }).observe(es);
    };
    vigilar(20);
  })();

  /* ---------------------------------------------------------------------
     COD-first strategy (2026-08-21): every persuasive path on the site —
     sticky bar, the "agregar al carrito" decision popup, the main buy box —
     now points here instead of Shopify's generic prepay-first checkout.
     Scrolls to the real COD toggle/form in the main buy box and opens it.
     --------------------------------------------------------------------- */
  function scrollToCodForm(){
    // Landing bienestar: el método de compra principal es el selector de pack
    // ([data-buy-selector]), que arma el carrito y va al checkout nativo.
    const sel = document.querySelector('[data-buy-selector]');
    if (sel){
      sel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    // Otros productos: formulario COD embebido de EasySell (#easysell).
    const es = document.querySelector('#easysell');
    if (es){
      // Si la landing tiene su propio "ir al formulario" (sincroniza el pack elegido), usamos ese.
      if (typeof window.tvbMqGoToForm === 'function') { window.tvbMqGoToForm(); return; }
      // Arriba del formulario (no al centro) y sin abrir el teclado solo: en celular el foco
      // automático durante el scroll dejaba el campo tapado.
      window.scrollTo({ top: es.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
      return;
    }
    const toggle = document.querySelector('[data-cod-quick-toggle]');
    if (!toggle) return;
    toggle.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const panel = document.querySelector('[data-cod-quick-form]');
    setTimeout(function(){
      if (panel && panel.style.display !== 'block') toggle.click();
      const firstField = document.querySelector('[data-cod-field="first_name"]');
      if (firstField) firstField.focus();
    }, 450);
  }
  window.TVB.scrollToCodForm = scrollToCodForm;

  document.addEventListener('click', function(e){
    const btn = e.target.closest('[data-sticky-cod-btn], [data-cod-scroll-btn]');
    if (!btn) return;
    scrollToCodForm();
  });

  /* ---------------------------------------------------------------------
     Interactive quiz
     --------------------------------------------------------------------- */
  (function quiz(){
    const root = document.querySelector('[data-quiz]');
    if (!root) return;
    const steps = Array.from(root.querySelectorAll('[data-quiz-step]'));
    const state = { goal:null, age:null, duration:null };

    function show(name){
      steps.forEach(s=> s.hidden = s.getAttribute('data-quiz-step') !== name);
    }
    function setProgress(pct){
      const bar = root.querySelector('[data-quiz-progress-bar]');
      if (bar) bar.style.width = pct + '%';
      const label = root.querySelector('[data-quiz-progress-label]');
      if (label) label.textContent = label.dataset.template.replace('{n}', pct === 33 ? '1' : pct === 66 ? '2' : '3');
    }

    root.addEventListener('click', function(e){
      const start = e.target.closest('[data-quiz-start]');
      if (start){ show('q1'); setProgress(33); }

      const restart = e.target.closest('[data-quiz-restart]');
      if (restart){ state.goal = state.age = state.duration = null; show('intro'); }

      const opt = e.target.closest('[data-quiz-option]');
      if (opt){
        const q = opt.closest('[data-quiz-step]').getAttribute('data-quiz-step');
        const value = opt.getAttribute('data-quiz-option');
        if (q === 'q1'){ state.goal = value; show('q2'); setProgress(66); }
        else if (q === 'q2'){ state.age = value; show('q3'); setProgress(100); }
        else if (q === 'q3'){
          state.duration = value;
          const resultId = computeResult(state.goal, state.age, state.duration);
          revealResult(resultId);
          show('result');
        }
      }
    });

    function computeResult(goal, age, dur){
      // Ported 1:1 from the original quiz recommendation logic. Result id 5
      // ("Próstata Vital 40+") is a discreet/private-purchase product on
      // purpose — it's reachable only via this quiz or a direct link, never
      // listed in the public catalog grid or collections.
      if (goal === 'pain') return dur === 'recent' ? 2 : 1;
      if (goal === 'sleep') return 3;
      if (goal === 'energy') return (age === '45-55' || age === '55plus') ? 5 : 6;
      return (age === '45-55' || age === '55plus') ? 8 : 7;
    }

    function revealResult(resultId){
      root.querySelectorAll('[data-quiz-result-card]').forEach(card=>{
        card.hidden = card.getAttribute('data-quiz-result-card') !== String(resultId);
      });
    }
  })();

  /* ---------------------------------------------------------------------
     Antes/Después drag-to-compare slider — touch + mouse via Pointer Events
     --------------------------------------------------------------------- */
  (function compareSlider(){
    document.querySelectorAll('[data-compare-slider]').forEach(function(root){
      const handle = root.querySelector('[data-compare-handle]');
      const clip = root.querySelector('[data-compare-clip]');
      if (!handle || !clip) return;
      let dragging = false;

      function setPos(clientX){
        const rect = root.getBoundingClientRect();
        let pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(0, Math.min(100, pct));
        root.style.setProperty('--pos', pct + '%');
      }

      function onMove(e){
        if (!dragging) return;
        const x = e.touches ? e.touches[0].clientX : e.clientX;
        setPos(x);
      }
      function onUp(){
        dragging = false;
        document.removeEventListener('pointermove', onMove);
        document.removeEventListener('pointerup', onUp);
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('touchend', onUp);
      }
      function onDown(e){
        dragging = true;
        root.dataset.hintPlayed = 'true'; // user is already interacting, skip the auto hint
        const x = e.touches ? e.touches[0].clientX : e.clientX;
        setPos(x);
        document.addEventListener('pointermove', onMove);
        document.addEventListener('pointerup', onUp);
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
        document.addEventListener('touchmove', onMove, { passive: true });
        document.addEventListener('touchend', onUp);
        if (e.cancelable) e.preventDefault();
      }

      root.addEventListener('pointerdown', onDown);
      root.addEventListener('mousedown', onDown);
      root.addEventListener('touchstart', onDown, { passive: true });

      // Hint sweep: once the slider scrolls into view, nudge it left-right-center
      // so it's obvious it's draggable, then hand control back to the user.
      if ('IntersectionObserver' in window){
        const io = new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if (!entry.isIntersecting || root.dataset.hintPlayed) return;
            root.dataset.hintPlayed = 'true';
            root.classList.add('tvb-compare--animating');
            const steps = [35, 65, 50];
            let i = 0;
            (function next(){
              if (i >= steps.length) { root.classList.remove('tvb-compare--animating'); return; }
              root.style.setProperty('--pos', steps[i] + '%');
              i++;
              setTimeout(next, 550);
            })();
          });
        }, { threshold: 0.6 });
        io.observe(root);
      }
    });
  })();

  /* ---------------------------------------------------------------------
     Antifaz landing: recolor shared/site-chrome sections (green -> navy/
     blue from the ad creatives) across the WHOLE page, only when the
     data-tvb-recolor marker is present (template.suffix landing-antifaz).
     This landing layout has no header/footer/nav, so a document-wide
     sweep is safe and doesn't touch other product pages.
     --------------------------------------------------------------------- */
  (function(){
    const marker = document.querySelector('[data-tvb-recolor="antifaz"]');
    if (!marker) return;
    const root = document;
    const styleMap = [
      ['#5FAE86', '#4A94FF'],
      ['#0E3026', '#030D22'],
      ['#0A241B', '#030D22'],
      ['rgba(95,174,134', 'rgba(74,148,255'],
      ['rgba(14,48,38', 'rgba(3,13,34'],
      ['#f0faf4', '#eef4ff']
    ];
    root.querySelectorAll('[style]').forEach(function(el){
      let s = el.getAttribute('style');
      let changed = false;
      styleMap.forEach(function(pair){
        if (s.indexOf(pair[0]) !== -1){ s = s.split(pair[0]).join(pair[1]); changed = true; }
      });
      if (changed) el.setAttribute('style', s);
    });
    ['stroke', 'fill'].forEach(function(attr){
      root.querySelectorAll('[' + attr + '="#5FAE86"]').forEach(function(el){ el.setAttribute(attr, '#4A94FF'); });
      root.querySelectorAll('[' + attr + '="#0E3026"]').forEach(function(el){ el.setAttribute(attr, '#030D22'); });
    });
  })();

  /* ---------------------------------------------------------------------
     Lazy-load below-the-fold <video> elements: only fetch + autoplay
     once the video scrolls near the viewport (saves data on first load).
     --------------------------------------------------------------------- */
  (function(){
    const lazyVideos = document.querySelectorAll('[data-lazy-video-src]');
    if (!lazyVideos.length) return;
    if (!('IntersectionObserver' in window)){
      lazyVideos.forEach(function(v){ v.src = v.dataset.lazyVideoSrc; v.play().catch(function(){}); });
      return;
    }
    const io = new IntersectionObserver(function(entries, obs){
      entries.forEach(function(entry){
        if (!entry.isIntersecting) return;
        const v = entry.target;
        v.src = v.dataset.lazyVideoSrc;
        v.play().catch(function(){});
        obs.unobserve(v);
      });
    }, { rootMargin: '300px 0px' });
    lazyVideos.forEach(function(v){ io.observe(v); });
  })();

  (function viewersWidget(){
    var el = document.querySelector('[data-viewers-widget]');
    if (!el) return;
    var countEl = el.querySelector('[data-viewers-count]');
    var base = parseInt(el.getAttribute('data-viewers-base'), 10) || 40;
    var current = base;
    function step(){
      var delta = Math.floor(Math.random() * 7) - 3;
      current = Math.max(base - 10, Math.min(base + 15, current + delta));
      if (countEl) countEl.textContent = current;
    }
    setInterval(step, 4000 + Math.random() * 4000);
  })();

  /* ---------------------------------------------------------------------
     Countdown widget — genérico, reutilizable en cualquier landing.
     Usa una fecha real puesta en data-countdown-target (ISO 8601).
     --------------------------------------------------------------------- */
  (function countdownWidgets(){
    var widgets = document.querySelectorAll('[data-countdown-target]');
    if (!widgets.length) return;
    function pad(n){ return String(n).padStart(2, '0'); }
    function tick(el){
      var target = new Date(el.getAttribute('data-countdown-target')).getTime();
      var now = Date.now();
      var diff = target - now;
      if (diff <= 0){
        el.querySelectorAll('[data-cd-d]').forEach(function(n){ n.textContent = '00'; });
        el.querySelectorAll('[data-cd-h]').forEach(function(n){ n.textContent = '00'; });
        el.querySelectorAll('[data-cd-m]').forEach(function(n){ n.textContent = '00'; });
        el.querySelectorAll('[data-cd-s]').forEach(function(n){ n.textContent = '00'; });
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.querySelectorAll('[data-cd-d]').forEach(function(n){ n.textContent = pad(d); });
      el.querySelectorAll('[data-cd-h]').forEach(function(n){ n.textContent = pad(h); });
      el.querySelectorAll('[data-cd-m]').forEach(function(n){ n.textContent = pad(m); });
      el.querySelectorAll('[data-cd-s]').forEach(function(n){ n.textContent = pad(s); });
    }
    widgets.forEach(function(el){
      tick(el);
      setInterval(function(){ tick(el); }, 1000);
    });
  })();

  /* ---------------------------------------------------------------------
     Exit-intent suave para el formulario COD (2026-08-29) — si la persona
     empieza a llenarlo y da señal de irse (cambia de pestaña/apps, o se
     aleja con scroll) sin enviarlo, le mostramos un recordatorio breve y
     no invasivo, una sola vez por sesión de página. Pensado mobile-first
     (visibilitychange funciona al cambiar de app; el scroll cubre el resto)
     ya que ahí está el 94%+ del tráfico real.
     --------------------------------------------------------------------- */
  (function codExitNudge(){
    var panel = document.querySelector('[data-cod-quick-form]');
    if (!panel) return;
    var formTouched = false;
    var nudgeShown = false;
    var wasHidden = false;

    panel.addEventListener('focusin', function(){ formTouched = true; });

    function buildNudge(){
      var nudge = document.createElement('div');
      nudge.setAttribute('data-cod-exit-nudge', '');
      nudge.style.cssText = 'position:fixed;left:16px;right:16px;bottom:16px;z-index:9999;background:#171520;color:#fff;border-radius:8px;padding:14px 16px;box-shadow:0 8px 24px rgba(0,0,0,0.25);display:flex;align-items:center;gap:12px;font-family:\'DM Sans\',sans-serif;';
      nudge.innerHTML = '<div style="flex:1;font-size:13px;line-height:1.4;">¿Tienes dudas? Tu pedido sigue con <strong>envío gratis</strong> y <strong>garantía de 3 meses</strong> — vuelve cuando quieras.</div>' +
        '<button type="button" data-cod-exit-nudge-cta style="flex-shrink:0;background:#C8A96E;color:#171520;border:none;border-radius:5px;padding:9px 14px;font-family:\'Montserrat\',sans-serif;font-weight:700;font-size:12px;cursor:pointer;">Volver</button>' +
        '<button type="button" data-cod-exit-nudge-close aria-label="Cerrar" style="flex-shrink:0;background:transparent;border:none;color:rgba(255,255,255,0.5);font-size:18px;cursor:pointer;line-height:1;">×</button>';
      document.body.appendChild(nudge);
      nudge.querySelector('[data-cod-exit-nudge-cta]').addEventListener('click', function(){
        panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        nudge.remove();
      });
      nudge.querySelector('[data-cod-exit-nudge-close]').addEventListener('click', function(){ nudge.remove(); });
      setTimeout(function(){ if (nudge.parentNode) nudge.remove(); }, 12000);
    }

    function maybeShowNudge(){
      if (nudgeShown || !formTouched) return;
      if (panel.getAttribute('data-cod-submitted') === 'true') return;
      nudgeShown = true;
      buildNudge();
    }

    document.addEventListener('visibilitychange', function(){
      if (document.hidden){ wasHidden = true; }
      else if (wasHidden){ maybeShowNudge(); }
    });

    var lastScrollY = window.scrollY;
    window.addEventListener('scroll', function(){
      var rect = panel.getBoundingClientRect();
      var scrolledAwayUp = window.scrollY < lastScrollY && rect.top > window.innerHeight + 400;
      if (formTouched && scrolledAwayUp) maybeShowNudge();
      lastScrollY = window.scrollY;
    }, { passive: true });
  })();

  /* ---------------------------------------------------------------------
     Fecha de entrega estimada: hoy + 2 días hábiles (salta domingo), en
     español de Chile. Rellena [data-delivery-eta] con "martes 2 de
     septiembre"; si falla, queda el texto de respaldo del HTML.
     --------------------------------------------------------------------- */
  (function deliveryEta(){
    var nodes = document.querySelectorAll('[data-delivery-eta]');
    if (!nodes.length) return;
    try {
      var d = new Date();
      var added = 0;
      while (added < 2){ d.setDate(d.getDate() + 1); if (d.getDay() !== 0) added++; }
      var dias = ['domingo','lunes','martes','miércoles','jueves','viernes','sábado'];
      var meses = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
      var txt = dias[d.getDay()] + ' ' + d.getDate() + ' de ' + meses[d.getMonth()];
      nodes.forEach(function(n){ if (!n.hasAttribute('data-eta-fixed')) n.textContent = txt; });
    } catch (e) {}
  })();

})();

/* audit redeploy 20260829T184426Z */
